import React, {Component} from 'react';
import TextInput from '../TextInput';
import CustomButton from '../CustomButton';
import styles from './Login.module.css';
import {SITE} from '../../../../shared/constants/URLs';

// SVGs
import { ReactComponent as AppLogo } from '../../../../shared/project-info/svgs-web/AppLogo.svg';

import {isNullOrEmpty, validateEmail} from '../../../../shared/utils/Helpers';
import {rwbApi} from '../../../../shared/apis/api';
import Loading from '../Loading';
import {logForgotPassword, logLogin} from '../../../../shared/models/Analytics';
import {INVALID_LOGIN_ERROR} from '../../../../shared/constants/ErrorMessages';
import ApiInfo from '../ApiInfo';
import { projectConfig } from '../../../../shared/project-info/projectConfig';
import { withOktaAuth } from '@okta/okta-react';
import { OktaAuth } from '@okta/okta-auth-js';
import { authentication } from '../../../../shared/models/Authentication';
import { userProfile } from '../../../../shared/models/UserProfile';
import registerProfileFlow from '../../../../shared/utils/RegisterProfileFlow';
export default withOktaAuth(class Login extends Component {
  
  state = {
    value: 0,
    email: '',
    password: '',
    email_error_text: null,
    password_error_text: null,
    isLoading: false,
    oktaSignIn:false
  };
  
  navigateForUser = (json) => {
    const { history, location } = this.props;
    const { email_verified, profile_completed, workspace } = json;
    if (!email_verified) {
      history.push(`/registration/confirm_email`);
    } else if (projectConfig.hasWorkspaces && workspace == null && !userProfile?.isOperator) {
      history.push(`/registration/work_space`);
    } else if (email_verified && !profile_completed) {
      const firstScreen = registerProfileFlow.getFirstScreen();
      history.push(`/registration/${firstScreen.path}`);
    } else {
      let referrer = location?.state?.referrer;
      if (referrer) {
        referrer = referrer.replace(window.location.origin, '');
        referrer = referrer.replace(window.port, '');
        history.replace(referrer);
      } else {
        history.replace('/feed');
      }
    }
  }

  async componentDidMount() {
    const { history } = this.props;
    // here okta call back handling is done when redirected from okta login page
    if (projectConfig.hasOktaAuthentication) {
      let okta_config = window.localStorage.getItem("oktaConfig");
      if (okta_config) {
        this.setState({ isLoading: true })
        let parsedOktaValue = JSON.parse(okta_config)
        let newOktaObj = {
          issuer: parsedOktaValue.discoveryUri,
          clientId: parsedOktaValue.clientId,
          redirectUri: window.location.origin + '/login/callback',
        }
        var authClient = new OktaAuth(newOktaObj);

        authClient.authStateManager.subscribe((authState) => {
          // Logic based on authState is done here.
          if (!authState.isAuthenticated) {
            // remove the okta config, and set the loading to false
            window.localStorage.removeItem("oktaConfig");
            this.setState({ isLoading: false });

            // render unauthenticated view
            return;
          }
          authentication.okta = true;

          authentication.setAuthentication({ access: authState?.accessToken?.accessToken, refresh: authState?.refreshToken?.refreshToken });
          rwbApi.getAuthenticatedUser().then((user) => {
            this.navigateForUser(user);
          })
          // Render authenticated view
        });

        // Handle callback
        if (authClient.token.isLoginRedirect()) {
          const { tokens } = await authClient.token.parseFromUrl(); // remember to "await" this async call
          authClient.tokenManager.setTokens(tokens);
        }
        // normal app startup
        authClient.start();
      }
    }
  }

  valueChangeHandler = (event, field) => {
    this.setState({[field]: event.target.value});
  };

  clearErrors() {
    this.setState({
      email_error_text: '',
      password_error_text: '',
    });
  }

  loginHandler = () => {
    authentication.okta = this.state.oktaSignIn;
    logLogin();
    let {email, password} = this.state;
    const {history} = this.props;

    this.clearErrors();
    let hasError = false;

    if (isNullOrEmpty(email) || !validateEmail(email)) {
      this.setState({email_error_text: 'PLEASE ENTER A VALID EMAIL'});
      hasError = true;
    }
    if (!hasError && this.state.oktaSignIn) {
      this.setState({isLoading:true});
      rwbApi.getOktaConfig(email).then((result) => { 
        let obj= {
          discoveryUri:result.discoveryUri,
          clientId:result.clientId,
          redirectUri: window.location.origin + '/login/callback',
        }
        window.localStorage.setItem(
          "oktaConfig",
          JSON.stringify(obj),
        );
        this.setState({
          oktaConfig:obj
        })
        this.props.oktaCallback(obj)
      }).catch((error) => {
        this.setState({isLoading:false,email_error_text:error.message.toUpperCase()});
        return;
      });
      return;
    }
    if (!password || password === null || password === '') {
      this.setState({password_error_text: 'ENTER YOUR PASSWORD'});
      hasError = true;
    }

    if (hasError) {
      return;
    }

    this.setState({
      email: email.trim(),
      isLoading: true,
    });
    rwbApi
      .loginUser(email, password)
      .then((json) => {
        this.setState({isLoading: false});
        this.navigateForUser(json);
      })
      .catch((error) => {
        console.warn(error);
        this.setState({
          password_error_text: INVALID_LOGIN_ERROR.toUpperCase(),
          isLoading: false,
        });
      });
  };
  oktaHandler = () => {
    this.setState({
      oktaSignIn: !this.state.oktaSignIn
    })
    authentication.okta = !authentication.okta;
  }

  oktaContactUs = () => {
    window.open(`mailto:${projectConfig.supportEmail}`)
  }
  render() {
    const {
      email,
      password,
      email_error_text,
      password_error_text,
      isLoading,
    } = this.state;
    return (
      <>
        <Loading size={100} color={'var(--white)'} loading={isLoading} />
        <div className="fullScreenContainer">
          <center><AppLogo width={250} height={250} /></center>
          <TextInput
            label={'Email'}
            type={'text'}
            value={email}
            onValueChange={(event) => this.valueChangeHandler(event, 'email')}
            error={email_error_text}
            onEnter={this.loginHandler}
          />
        {!this.state.oktaSignIn &&  <TextInput
            label={'Password'}
            type={'password'}
            value={password}
            onValueChange={(event) =>
              this.valueChangeHandler(event, 'password')
            }
            error={password_error_text}
            onEnter={this.loginHandler}
          />
          }
          {!this.state.oktaSignIn ? <p className={styles.forgotPasswordText}>
            Forgot your password?{' '}
            <a
              className="link"
              onClick={logForgotPassword}
              href={SITE.lostpassword}>
              Click Here
            </a>
          </p> :

            <p className={styles.forgotPasswordText}> Enter the email that you use for your organization's SSO. Having trouble?  <a
              className="link"
              onClick={this.oktaContactUs}
            >
              Contact us
            </a></p>
          }
          <CustomButton
            label="Sign In"
            buttonStyle="primary"
            onClick={this.loginHandler}
          />
          {projectConfig.hasOktaAuthentication &&
            <>

              {!this.state.oktaSignIn && <CustomButton
                label="Sign In With SSO"
                buttonStyle="primary"
                onClick={this.oktaHandler}
              />}
            </>
          }
          {this.state.oktaSignIn ?
            <CustomButton
              buttonStyle="secondary"
              label="RETURN TO SIGN IN"
              onClick={this.oktaHandler}
            />
        :  <CustomButton
            link={true}
            to="/registration"
            label="Create Account"
            buttonStyle="secondary"
          />}
          <ApiInfo />
        </div>
      </>
    );
  }
}
)